import { Component, OnInit } from '@angular/core';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-security-page',
    templateUrl: './security-page.component.html',
    styleUrls: ['./security-page.component.scss'],
    standalone: false
})
export class SecurityPageComponent implements OnInit {
  public activeTheme: any;
  public isDefaultTheme: boolean;
  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
  }

}
